import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/base.css";
import "./styles/shell.css";
import "./styles/welcome.css";
import "./styles/landing.css";
import "./styles/studio.css";
import "./styles/project.css";
import "./styles/pages.css";
import "./styles/voices.css";
import "./styles/making.css";
import "./styles/plans.css";
import { App } from "./App";
import { Button, Logo } from "./components";
import { takeRedemption } from "./Account";
import { bilingual, useText } from "./i18n";
import { report, watchErrors } from "./report";

const TEXT = bilingual({
  en: {
    title: "Let’s get you back to the studio.",
    saved: "Your work is saved. Reload to reconnect.",
    reload: "Reload studio",
  },
  es: {
    title: "Volvamos al estudio.",
    saved: "Tu trabajo está guardado. Recarga para volver a conectar.",
    reload: "Recargar estudio",
  },
});

/** What a crash shows; it reads the language itself, outside the app. */
function Fatal() {
  const t = useText(TEXT);
  return (
    <main className="fatal" role="alert">
      <Logo />
      <h1 className="h1">{t.title}</h1>
      <p>{t.saved}</p>
      <Button className="primary" onClick={() => window.location.reload()}>
        {t.reload}
      </Button>
    </main>
  );
}

class StudioBoundary extends React.Component<
  { children: React.ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(e: Error) {
    report("crash", e);
  }
  render() {
    return this.state.failed ? <Fatal /> : this.props.children;
  }
}
watchErrors();
// A Señal credit link leaves the address bar before anything else runs.
takeRedemption();
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StudioBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StudioBoundary>
  </React.StrictMode>,
);
